module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/result/photo01-37a2399ae6dc5ebc533241b4f215a3c0.png";